<template>
  <div class="my-0 py-0">
    <div v-if="esPop === false">
      <div class="d-flex">
        <div class="col-4">
          <!--Componente imagen-->
          <component
            v-show="showImg"
            :isModal="true"
            v-bind:is="img"
            :data="data"
            :idSection="idSection"
            :subid="subid"
            :online="online"
            @setted="setImg"
            :elementid="elementid"
          ></component>
        </div>
        <div class="col-6 p-2 mx-2 mt- bg-light" v-show="showImg">
          <h3>Opciones del PopUp</h3>
          <!--Color de fondo del modal -->
          <div>
            <label for="type-color" class="font-weight-bold">Color de Fondo:</label>
            <b-form-input v-model="colorbg" id="type-color" type="color"></b-form-input>
          </div>
          <hr />
          <!--Opacidad del fondo del modal-->
          <div>
            <label for="type-range" class="font-weight-bold">Opacidad del Fondo:</label>
            <b-form-input v-model="opbg" id="type-range" type="range" min="0" max="10"></b-form-input>
            <p>Valor: {{ opbg }}</p>
          </div>
          <hr />
          <!--Tamaño de la imagen en el modal-->
          <p class="font-weight-bold">Tamaño de la Imagen en el PopUp</p>
          <b-button-toolbar class="m-1">
            <b-button class="mx-1" size="sm" variant="info" v-on:click="modalSize = 30">Chico</b-button>
            <b-button class="mx-1" size="sm" variant="info" v-on:click="modalSize = 50">Mediano</b-button>
            <b-button class="mx-1" size="sm" variant="info" v-on:click="modalSize = 100">Grande</b-button>
          </b-button-toolbar>
        </div>
      </div>
      <!--Botones de Confirmación y Edición-->
      <div class="d-flex justify-content-end my-0 py-0">
        <b-button
          variant="success"
          v-show="showBtn"
          v-on:click="
            saveAll(), (showImg = false), (showThumb = true), (showBtn = false)
          "
        >Guardar cambios</b-button>
        <!--Dropdown de edición-->
        <b-dropdown
          id="dropdown-1"
          size="sm"
          variant="info"
          text="Editar"
          right
          class="btn-elemento btn-options"
          :class="{ ocultarClass: esHome }"
          v-show="showThumb"
          v-on:click="
            ;(showPosition = false), (showAnimation = false), (showSize = false)
          "
        >
          <b-dropdown-item
            @click=";(showImg = true), (showThumb = false), (showBtn = true)"
          >Editar PopUp</b-dropdown-item>
          <b-dropdown-item
            @click="showSize == true ? (showSize = false) : (showSize = true)"
          >Ajustar tamaño</b-dropdown-item>
          <b-dropdown-item
            @click="
              showMargin == true ? (showMargin = false) : (showMargin = true)
            "
          >Agregar margen</b-dropdown-item>
          <b-dropdown-item
            @click="
              showAnimation == true
                ? (showAnimation = false)
                : (showAnimation = true)
            "
          >Agregar animación</b-dropdown-item>
          <b-dropdown-item
            @click="
              showPosition == true
                ? (showPosition = false)
                : (showPosition = true)
            "
          >Ajustar posición</b-dropdown-item>
        </b-dropdown>
      </div>

      <!--NOTE menu margen-->
      <div v-show="showMargin" class="row">
        <div class="col-8 px-0 mx-0 posicionar-container">
          <div class="posicionar-titulo p-2 pl-3">
            <p class="h5">Agregar Márgenes</p>
          </div>

          <div class="p-3">
            <div class="d-flex flex-row justify-content-around">
              <div style="overflow:hidden ">
                <label for="left">Margen izquierdo</label>
                <input
                  v-model.number="localMargin['ml']"
                  type="number"
                  min="0"
                  max="8"
                  name="left"
                  id
                />
              </div>

              <div style="overflow:hidden ">
                <label for="top">Margen superior</label>
                <input
                  v-model.number="localMargin['mt']"
                  type="number"
                  min="0"
                  max="8"
                  name="top"
                  id
                />
              </div>
            </div>
            <div class="d-flex flex-row justify-content-around my-2">
              <div style="overflow:hidden">
                <label for="right">Margen derecho</label>
                <input
                  v-model.number="localMargin['mr']"
                  type="number"
                  min="0"
                  max="8"
                  name="right"
                  id
                />
              </div>
              <div style="overflow:hidden">
                <label for="bottom">Margen inferior</label>
                <input
                  v-model.number="localMargin['mb']"
                  type="number"
                  min="0"
                  max="8"
                  name="bottom"
                />
              </div>
            </div>
          </div>
          <div class="col">
            <div @click="addMargin" class="btn btn-primary m-2">Aplicar</div>

            <div
              @click="
                showMargin == true ? (showMargin = false) : (showMargin = true)
              "
              class="btn btn-danger m-2"
            >Cerrar</div>
          </div>
        </div>
      </div>

      <div v-show="showAnimation" class="options">
        <div class="px-0 mx-0 posicionar-container">
          <div class="posicionar-titulo p-2 pl-3">
            <p class="h5">Agregar animacion</p>
          </div>
          <div class="p-3">
            <div class="d-flex flex-row justify-content-around">
              <div
                @click="addAnimation('fade')"
                class="btn btn-primary py-2 px-2 animation-fade"
              >FadeIn</div>
              <div style="overflow:hidden ">
                <div
                  @click="addAnimation('bounce')"
                  class="btn btn-warning py-2 px-2 animation-bounce"
                >Bounce</div>
              </div>
            </div>
            <div class="d-flex flex-row justify-content-around my-2">
              <div style="overflow:hidden">
                <div
                  @click="addAnimation('lr')"
                  class="btn btn-primary py-2 px-2 animation-slide-l-r"
                >Slide in</div>
              </div>
              <div style="overflow:hidden">
                <div
                  @click="addAnimation('rl')"
                  class="btn btn-warning py-2 px-2 animation-slide-r-l"
                >Slide in</div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <b-button size="sm" v-on:click="showAnimation = false" variant="success">Guardar</b-button>
            </div>
          </div>
        </div>
      </div>
      <div v-show="showPosition" class="pb-2 options">
        <div class="px-0 mx-0 posicionar-container">
          <div class="posicionar-titulo p-2 pl-3">
            <p class="h3">Posicionar</p>
          </div>
          <div class="p-3">
            <b-button-group size="sm" class="d-flex flex-row justify-content-center">
              <b-button
                @click="changePosition('left')"
                class="mx-4"
                active
                variant="outline-success"
              >
                <img src="@/assets/f-left.svg" alt />
              </b-button>
              <b-button @click="changePosition('center')" class="mx-4" variant="outline-info">
                <img src="@/assets/f-center.svg" alt />
              </b-button>
              <b-button @click="changePosition('right')" class="mx-4" variant="outline-warning">
                <img src="@/assets/f-right.svg" alt />
              </b-button>
            </b-button-group>
          </div>
          <div class="d-flex justify-content-end">
            <b-button size="sm" v-on:click="showPosition = false" variant="success">Guardar</b-button>
          </div>
        </div>
      </div>
      <!--Menu cambiar tamaño de la img-->
      <div v-show="showSize" class="pb-2 options">
        <div class="px-0 mx-0 posicionar-container">
          <div class="posicionar-titulo p-2 pl-3">
            <p class="h3">Tamaño de la imagen</p>
          </div>
          <b-button-toolbar class="m-1">
            <b-button class="mx-1" size="sm" variant="info" v-on:click="imgSize = 30">Chico</b-button>
            <b-button class="mx-1" size="sm" variant="info" v-on:click="imgSize = 50">Mediano</b-button>
            <b-button class="mx-1" size="sm" variant="info" v-on:click="imgSize = 75">Grande</b-button>
            <b-button class="mx-1" size="sm" variant="info" v-on:click="imgSize = 100">100%</b-button>
          </b-button-toolbar>
          <div class="d-flex justify-content-end">
            <b-button
              size="sm"
              v-on:click=";(showSize = false), saveAll()"
              variant="success"
            >Guardar</b-button>
          </div>
        </div>
      </div>

      <!--Modal -->
      <div
        id="modalimg"
        class="modalthis"
        :style="'background-color: ' + hexToRgbA(colorbg, opbg)"
        v-show="showModalImg"
        v-on:click="showModalImg = false"
      >
        <div class="modal-content-imagen">
          <img :src="url" class="py-1" :style="'width: ' + modalSize + '%;'" />
          <span v-on:click="showModalImg = false" class="close">&times;</span>
        </div>
      </div>
      <!--Imagen renderizada con modal -->
      <div ref="imgcontainer" class="d-flex flex-row clic">
        <img
          ref="imgref"
          :src="url"
          v-show="showThumb"
          :style="'width: ' + imgSize + '%;'"
          class="py-1 img-element clic"
          alt
          v-on:click="showModal"
        />
      </div>
    </div>

    <!--NOTE Si es un conjunto de pop ups-->
    <div v-else>
      <div class="d-flex">
        <div class="col-4">
          <!--Componente imagen-->
          <component
            v-show="showImgPop"
            :isModal="true"
            v-bind:is="img"
            :isPop="true"
            :idPop="idPop"
            :data="data"
            :idSection="idSection"
            :subid="subid"
            :online="online"
            @setted="setImg"
            :elementid="elementid"
          ></component>
        </div>
        <div class="col-6 px-2 mx-2 bg-light" v-show="showImgPop">
          <h3>Opciones del PopUp</h3>
          <!--Color de fondo del modal -->
          <div>
            <label for="type-color" class="font-weight-bold">Color de Fondo:</label>
            <b-form-input v-model="colorbg" id="type-color" type="color"></b-form-input>
          </div>
          <!--Color del circulito -->
          <p class="h3">Color del circulo</p>

          <b-button-toolbar class="m-1">
            <b-button class="mx-1" size="sm" variant="link" v-on:click="dotcolor = 1">
              <img src="pops/01.png" class="mincir" />
            </b-button>
            <b-button class="mx-1" size="sm" variant="link" v-on:click="dotcolor = 2">
              <img src="pops/02.png" class="mincir" />
            </b-button>
            <b-button class="mx-1" size="sm" variant="link" v-on:click="dotcolor = 3">
              <img src="pops/03.png" class="mincir" />
            </b-button>
            <b-button class="mx-1" size="sm" variant="link" v-on:click="dotcolor = 4">
              <img src="pops/04.png" class="mincir" />
            </b-button>
            <b-button class="mx-1" size="sm" variant="link" v-on:click="dotcolor = 5">
              <img src="pops/05.png" class="mincir" />
            </b-button>
            <b-button class="mx-1" size="sm" variant="link" v-on:click="dotcolor = 6">
              <img src="pops/06.png" class="mincir" />
            </b-button>
            <b-button class="mx-1" size="sm" variant="link" v-on:click="dotcolor = 7">
              <img src="pops/07.png" class="mincir" />
            </b-button>
            <b-button class="mx-1" size="sm" variant="link" v-on:click="dotcolor = 8">
              <img src="pops/08.png" class="mincir" />
            </b-button>
          </b-button-toolbar>
          <hr />
          <!--Opacidad del fondo del modal-->
          <div>
            <label for="type-range" class="font-weight-bold">Opacidad del Fondo:</label>
            <b-form-input v-model="opbg" id="type-range" type="range" min="0" max="10"></b-form-input>
            <p>Valor: {{ opbg }}</p>
          </div>

          <hr />
        </div>
      </div>
      <div class="d-flex justify-content-end mx-2 my-0 py-0">
        <b-button
          variant="success"
          v-show="showBtnPop"
          v-on:click="
            saveAll(),
              (showImgPop = false),
              (showThumbPop = true),
              (showBtnPop = false)
          "
        >Guardar cambios</b-button>
      </div>

      <!--Modal -->

      <div
        id="modalimg"
        class="modalthis"
        :style="'background-color: ' + hexToRgbA(colorbg, opbg)"
        v-show="showModalImg"
        v-on:click="showModalImg = false"
      >
        <div class="modal-content-imagen">
          <img ref="modalimgref" :src="url" class="py-0" />
          <span v-on:click="showModalImg = false" class="close">&times;</span>
        </div>
      </div>
      <!--El circulito -->
      <div ref="imgcontainer" class="d-flex flex-column">
        <img
          :src="'pops/0' + dotcolor + '.png'"
          v-show="showThumbPop"
          class="px-1 clic"
          v-on:click="showModal"
        />
        <b-button
          :class="{ ocultarClass: esHome }"
          class="mr-1"
          size="sm"
          variant="warning"
          v-show="showThumbPop"
          v-on:click="
            ;(showImgPop = true), (showThumbPop = false), (showBtnPop = true)
          "
        >
          <font-awesome-icon icon="edit" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Imagen from '@/components/atomos/Imagen.vue'
export default {
  name: 'ImgModal',
  components: { Imagen },
  props: {
    id: String,
    esPop: Boolean,
    data: Object,
    subid: Number,
    idSection: String,
    idPop: Number,
    esHome: Boolean,
    online: Boolean,
    elementid: Number
  },
  data() {
    return {
      showThumb: true,
      showImg: false,
      showBtn: false,
      showModalImg: false,
      showPosition: false,
      showAnimation: false,
      showMargin: false,
      showSize: false,
      url: '',
      img: 'Imagen',
      colorbg: '#ffffff',
      opbg: 10,
      imgSize: 50,
      modalSize: 50,
      showImgPop: false,
      showBtnPop: false,
      showThumbPop: true,
      dotcolor: 1,
      position: 'left',
      localMargin: {
        mt: 0,
        mr: 0,
        mb: 0,
        ml: 0
      },
      localPadding: {
        pt: 0,
        pr: 0,
        pb: 0,
        pl: 0
      }
    }
  },
  created() {
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    //TODO la validación de si es online u offline, default online (firebase)
    if (this.esPop) {
      if (this.online) {
        this.url = this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[this.idPop]['url']
      } else {
        this.url =
          'imgs/' +
          this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid].extras[this.idPop]['name']
      }
      this.localPadding = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid].extras[
        this.idPop
      ]['padding']
      this.localMargin = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid].extras[
        this.idPop
      ]['margin']
      this.modalSize = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid].extras[
        this.idPop
      ]['sizeM']
      this.colorbg = this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras[this.idPop]['bgcolorM']
      this.opbg = this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras[this.idPop]['opM']
      this.dotcolor = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid].extras[
        this.idPop
      ]['dotcolor']
    } else {
      this.animation = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid]['animation']
      //si esta conectado a internet la src de la img cambia
      if (this.online) {
        this.url = this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['src'][0]['url']
      } else {
        this.url =
          'imgs/' +
          this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid]['src'][0]['name']
      }

      this.localMargin = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid]['margin']
      this.localPadding = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid]['padding']
      this.position = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid]['position']
      this.imgSize = this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['size']
      this.modalSize = this.localRoot['componentes']['secciones'][
        this.idSection
      ]['subsecciones'][this.subid]['elements'][this.elementid].extras[0][
        'sizeM'
      ]
      this.colorbg = this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras[0]['bgcolorM']
      this.opbg = this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid].extras[0]['opM']
      this.imgSize = this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['size']
    }
  },
  mounted() {
    this.addAnimation(this.animation)
    this.changePosition(this.position)
    this.addMargin()
  },
  methods: {
    addMargin() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      let textElementMargin = this.$refs.imgref

      if (textElementMargin === undefined) return

      // let textElementMargin = this.$refs.imgref
      textElementMargin.className = ''

      textElementMargin.classList.add('d-flex', 'flex-row', 'clic')

      textElementMargin.classList.add(
        'pt-' + this.localPadding['pt'],
        'mt-' + this.localMargin['mt']
      )
      textElementMargin.classList.add(
        'pr-' + this.localPadding['pr'],
        'mr-' + this.localMargin['mr']
      )
      textElementMargin.classList.add(
        'pb-' + this.localPadding['pb'],
        'mb-' + this.localMargin['mb']
      )
      textElementMargin.classList.add(
        'pl-' + this.localPadding['pl'],
        'ml-' + this.localMargin['ml']
      )

      if (this.esPop) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[this.idPop][
          'padding'
        ] = this.localPadding
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[this.idPop][
          'margin'
        ] = this.localMargin
      } else {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['padding'] = this.localPadding
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['margin'] = this.localMargin
      }

      window.localStorage.setItem('root', JSON.stringify(this.localRoot))
    },

    setImg(value) {
      this.url = value
    },
    //Muestra el modal, hice un metodo porque quería hacer mas cosas antes de mostrar el modal
    showModal() {
      this.showModalImg = true
    },
    hexToRgbA(hex, op) {
      var c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        var opacidad
        opacidad = op / 10
        return (
          'rgba(' +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
          ',' +
          opacidad +
          ')'
        )
      }
      alert('Bad Hex')
    },
    addAnimation(type) {
      if (type === '') return

      this.animation = ''
      switch (type) {
        case 'rl':
          this.animation = 'rl'
          break

        case 'lr':
          this.animation = 'lr'
          break

        case 'bounce':
          this.animation = 'bounce'
          break

        case 'fade':
          this.animation = 'fade'
          break

        default:
          break
      }
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'][this.idSection].subsecciones[
        this.subid
      ]['elements'][this.elementid]['animation'] = this.animation

      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    changePosition(value) {
      this.position = ''
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      switch (value) {
        case 'left':
          this.$refs.imgcontainer.classList.remove('justify-content-end')
          this.$refs.imgcontainer.classList.remove('justify-content-center')
          this.$refs.imgcontainer.classList.add('justify-content-start')
          this.position = 'left'
          break
        case 'center':
          this.$refs.imgcontainer.classList.remove('justify-content-start')
          this.$refs.imgcontainer.classList.remove('justify-content-end')
          this.$refs.imgcontainer.classList.add('justify-content-center')
          this.position = 'center'
          break
        case 'right':
          this.$refs.imgcontainer.classList.remove('justify-content-start')
          this.$refs.imgcontainer.classList.remove('justify-content-center')
          this.$refs.imgcontainer.classList.add('justify-content-end')
          this.position = 'right'
          break

        default:
          break
      }
      //Se guarda la posición del elemento en root
      this.localRoot['componentes']['secciones'][this.idSection][
        'subsecciones'
      ][this.subid]['elements'][this.elementid]['position'] = this.position

      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    saveAll() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      if (this.esPop) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[this.idPop][
          'bgcolorM'
        ] = this.colorbg
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[this.idPop][
          'sizeM'
        ] = this.modalSize
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[this.idPop][
          'opM'
        ] = this.opbg
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[this.idPop][
          'dotcolor'
        ] = this.dotcolor

        if (this.online) {
          this.url = this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid].extras[this.idPop]['url']
        } else {
          this.url =
            'imgs/' +
            this.localRoot['componentes']['secciones'][this.idSection][
              'subsecciones'
            ][this.subid]['elements'][this.elementid].extras[this.idPop]['name']
        }
      } else {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[0][
          'bgcolorM'
        ] = this.colorbg
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[0][
          'sizeM'
        ] = this.modalSize
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid].extras[0]['opM'] = this.opbg
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['size'] = this.imgSize
        if (this.online) {
          this.url = this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid]['src'][0]['url']
        } else {
          this.url =
            'imgs/' +
            this.localRoot['componentes']['secciones'][this.idSection][
              'subsecciones'
            ][this.subid]['elements'][this.elementid]['src'][0]['name']
        }
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    }
  }
}
</script>

<style scoped>
.clic:hover {
  cursor: pointer;
}

.modalthis {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: auto;
}

/* Modal Content (Image) */
.modal-content-imagen {
  margin: 100px auto;
  display: inline-block;
  width: 90%;
  text-align: center;
  font-size: 30px;
  position: relative;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/*Cerrar Modal */
.close {
  position: absolute;
  top: -10px;
  right: -10px;
  color: #000;
  font-size: 50px;
  line-height: 20px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

/*Editar Imagen*/

.options {
  position: absolute;
  top: 10;
  right: 0;
  z-index: 10;
}

.img-element {
  /*height: 200px;
  width: 400px;*/
  position: relative;
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
}

/*Animación y posición de la imagen*/
.base-animation {
  opacity: 1;
}
.fade-in {
  animation-name: fadeIn;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-delay: 0;
  animation-play-state: running;
}

.animation-fade {
  animation-name: fadeIn;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 0;
  animation-play-state: running;
}
.animation-slide-l-r {
  position: relative;
  animation-name: slidelr;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-slide-r-l {
  position: relative;
  animation-name: sliderl;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-bounce {
  position: relative;
  animation-name: bounce;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: none;
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.posicionar-container {
  background-color: #eaf0e9;
  border: solid #b1b0b0 2px;
  border-radius: 8px;
}
.posicionar-titulo {
  /* background-color: antiquewhite; */
  border-bottom: solid #b1b0b0 2px;
  border-radius: 8px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slidelr {
  from {
    right: 3em;
    opacity: 0;
  }
  to {
    right: 0em;
    opacity: 1;
  }
}
@keyframes sliderl {
  from {
    left: 3em;
    opacity: 0;
  }
  to {
    left: 0em;
    opacity: 1;
  }
}
@keyframes bounce {
  from {
    bottom: 2.5em;
    opacity: 0;
  }
  to {
    bottom: 0em;
    opacity: 1;
  }
}

.mincir {
  width: 30px !important;
  height: 30px !important;
}
</style>
